import React from 'react';
import BoostedComponent from './BoostedComponent';
import moment from 'moment-with-locales-es6';


class ReservationSeuleSommaire extends BoostedComponent {
  constructor(props) {
    super(props)
    this.state = {
      aReserver: this.props.aReserver ? this.props.aReserver : [],
      lastRequest: ""
    }
    this.constants = this.props.constants
    this.getCouts = this.getCouts.bind(this)
  }
  componentDidUpdate(prevProps) {
    if (this.props.aReserver !== prevProps.aReserver) {
      this.setState({
        aReserver: this.props.aReserver ? this.props.aReserver : []
      })
      
    }

    this.getCouts()
    console.log(this.props.aReserver)
  }
  getCouts() {
    if (this.props.aReserver && this.props.aReserver.length>0 && this.state.lastRequest !== JSON.stringify(this.props.aReserver)) {
      this.setState({ lastRequest: JSON.stringify(this.props.aReserver) })
      window.jQuery.ajax({
        dataType: 'json',
        url: this.props.constants.ajaxurl,
        method: 'POST',
        crossDomain: true,
        data: {
          action: 'schedulePublicGetCouts',
          activite: JSON.stringify(this.props.aReserver),
          categorie: 1,
          type: this.props.constants.options.type

        },
        success: (response) => {
          this.setState({
            couts: response
          })
        },
        error: () => {
          this.getCouts()
        }
      });
    }
  }
  render() {

    moment.locale(this.constants.locale)
    return (<div className="resumeReservation" > {
      this.state.aReserver && this.state.aReserver.length > 1 &&
      <p className="ReservationResume" > {
        this.state.aReserver.length
      } {
          this.constants.semaines
        } & times; {
          this.temps2string(this.state.aReserver[0].fin - this.state.aReserver[0].debut, false)
        } = {
          (((this.state.aReserver[0].fin - this.state.aReserver[0].debut) / (60 * 60) * this.state.aReserver.length) + "").replace('.', ',')
        } {
          this.constants.heures
        } </p>
    } <h3 > {
      this.constants.sommaireReservation
    }
      </h3> <table className="sommaireReservation" >
        <thead >
          <tr >
            <th > # </th> <th > {
              this.constants.date
            } </th> <th> {
              this.constants.heures
            } </th> <th> {
              this.constants.duree
            } </th> </tr> </thead> <tbody > {
              this.state.aReserver.map((item, index) =>
                <tr key={
                  index
                }>
                  <td > {
                    (index + 1)
                  } </td>  <td > {
                    (moment.utc(item.debut * 1000).format('dddd, ll'))
                  } </td>  <
                    td > {
                      (moment.utc(item.debut * 1000).format('HH:mm'))
                    }
                    / {(moment.utc(item.fin * 1000).format('HH:mm'))}</td >
                  <td > {
                    this.tempsStringAlt(this.temps2string(item.fin - item.debut))
                  } </td> </tr>
              )
            } </tbody> </table> {
        this.state.couts &&
        <div >
          <h3 > {
            this.constants.sommaireCouts
          } </h3> <table className="sommaireCouts" >
            <thead >
              <tr >
                <th > {
                  this.constants.item
                } </th> <th > {
                  this.constants.tarif
                } </th> <th > {
                  this.constants.total
                } </th> </tr> </thead> <tbody > {
                  this.state.couts.map((item, index) =>
                    <tr key={
                      index
                    } >
                      <td> {
                        (item.nom) ? item.nom : this.tempsStringAlt(this.temps2string(item.temps * 3600))
                      } </td> <td > {
                        (item.tauxStr) ? item.tauxStr : this.formatCash(item.taux) + "/h"
                      } </td> <td > {
                        this.formatCash(item.total)
                      } </td>  </tr>
                  )
                }

            </tbody> <tfoot >
              <tr >
                <td colSpan="2" > {
                  this.constants.total
                } </td> <td > {
                  this.formatCash(this.state.couts.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.total
                  }, 0))
                } </td>  </tr> </tfoot> </table> </div>

      } </div>
    )

  }
}
export default ReservationSeuleSommaire;


// WEBPACK FOOTER //
// ./src/ReservationSeule4.js